import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { MySavedColorsButton } from "./components/my-saved-colors/my-saved-colors-button";
import { queryClient } from "../../src/js/api/queryClient";

const MySavedColorsContext = createContext();
export const useMySavedColors = () => useContext(MySavedColorsContext);
function MySavedColorsProvider({ data, children }) {
  return (
    <MySavedColorsContext.Provider value={data}>
      {children}
    </MySavedColorsContext.Provider>
  );
}

function MySavedColorsRenderer() {
  const elements = document.querySelectorAll(".react-my-saved-colors");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for MySavedColors"
      );
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <MySavedColorsProvider data={initialProps}>
            <MySavedColorsButton />
          </MySavedColorsProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initMySavedColors = () => {
  if (document.readyState !== "loading") {
    MySavedColorsRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", MySavedColorsRenderer);
  }
};
